require('./src/flowchart.shim');
var parse = require('./src/flowchart.parse');
require('./src/jquery-plugin');

var FlowChart = {
	parse: parse
};

if (typeof window !== 'undefined') {
	window.flowchart = FlowChart;
}

module.exports = FlowChart;



//////////////////
// WEBPACK FOOTER
// ./node_modules/flowchart.js/index.js
// module id = 411
// module chunks = 0